import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-full col-span-1 text-center bg-white border divide-y divide-gray-200 shadow-sm rounded-t-2xl show-card" }
const _hoisted_2 = { class: "flex flex-col flex-1 px-8 py-6" }
const _hoisted_3 = ["alt", "href", "title"]
const _hoisted_4 = ["alt", "src", "title"]
const _hoisted_5 = { class: "mt-6 font-medium text-gray-900 text-md" }
const _hoisted_6 = { class: "flex flex-col justify-between flex-grow mt-1" }
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = {
  key: 0,
  class: "mb-2 text-sm text-slate-600 line-clamp-2"
}
const _hoisted_9 = { class: "text-xs font-medium text-clay-600" }
const _hoisted_10 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_11 = {
  key: 0,
  class: "inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-clay-800 bg-clay-50 hover:border-clay-900 hover:border hover:text-clay-700 hover:bg-clay-100"
}
const _hoisted_12 = {
  key: 1,
  class: "inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-clay-800 bg-clay-50 hover:border-clay-900 hover:border hover:text-clay-700 hover:bg-clay-100"
}
const _hoisted_13 = { class: "flex justify-center pt-6 text-sm" }

import {computed, onMounted, Ref, ref} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {TalentSearchProfileDTO} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'TalentProfileCard',
  props: {
    talent: {},
},
  setup(__props) {

// @ts-ignore
const props = __props

const talent: TalentSearchProfileDTO = props.talent;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        alt: _unref(talent).displayName,
        href: `/talent/${_unref(talent).profileUrl}`,
        title: _unref(talent).displayName,
        class: "guide-img-container"
      }, [
        _createElementVNode("img", {
          alt: _unref(talent).displayName,
          src: _unref(talent).headShotUrl,
          title: _unref(talent).displayName,
          class: "min-w-full mx-auto shrink-0 rounded-2xl"
        }, null, 8, _hoisted_4),
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(talent).displayName), 1)
      ], 8, _hoisted_3),
      _createElementVNode("dl", _hoisted_6, [
        _createElementVNode("dt", _hoisted_7, _toDisplayString(_unref(talent).displayName), 1),
        (_unref(talent).roles)
          ? (_openBlock(), _createElementBlock("dd", _hoisted_8, _toDisplayString(_unref(talent).roles.join(", ")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("dd", _hoisted_9, _toDisplayString(_unref(talent).shortAddressPrettified), 1),
        _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "sr-only" }, "Role", -1)),
        (_unref(talent).vocalPart || _unref(talent).ageRange)
          ? (_openBlock(), _createElementBlock("dd", _hoisted_10, [
              (_unref(talent).vocalPart)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(talent).vocalPart), 1))
                : _createCommentVNode("", true),
              (_unref(talent).ageRange)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(talent).ageRange), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(Fanning, {
            id: _unref(talent).id,
            "number-of-fans": _unref(talent).fanCount
          }, null, 8, ["id", "number-of-fans"]),
          _createVNode(Bookmarking, {
            id: _unref(talent).id
          }, null, 8, ["id"])
        ])
      ])
    ])
  ]))
}
}

})